/**
 * Grup başlıkları CSS ile büyük harfe çevrilir; `<html lang="en">` iken "Deneyim" → "DENEYIM" olur
 * (Türkçede DENEYİM). Türkçe harf içeren başlık `lang="tr"` alır, İngilizce başlıklar etkilenmez
 * (tr kuralıyla "Billing" → "BİLLİNG" olurdu). #1121
 */
const TURKISH_LETTER = /[çğıöşüÇĞİÖŞÜ]/

export function groupLabelLang(label: string): 'tr' | undefined {
  return TURKISH_LETTER.test(label) ? 'tr' : undefined
}
